import React, {Component, Fragment} from 'react';
import {Card, CardBody, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {Colxx, Separator} from '../../../components/common/CustomBootstrap';
import moment from 'moment';
import {reactTableText} from '../../../constants/configs';
import Breadcrumb from '../../../containers/navs/Breadcrumb';
import ReactTable from 'react-table';
import Api from '../../../services/Api';
import {i18nizeDate} from '../../../helpers/Utils';
import {keyBy, mapValues, omit} from 'lodash';
import ToolTip from '../../../components/ToolTip';
import ReactTableSelectFilter from '../../../components/ReactTableSelectFilter';
import ReactTableDateFilter from '../../../components/ReactTableDateFilter';
import ReactTableTextFilter from '../../../components/ReactTableTextFilter';

class Lists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      pages: -1,
      loading: false,
      selectedStartDate: null,
      selectedEndDate: null,
    };
    this.renderEmailConfirmedFilter = this.renderEmailConfirmedFilter.bind(this);
    this.renderMobileConfirmedFilter = this.renderMobileConfirmedFilter.bind(this);
    this.renderDateFilter = this.renderDateFilter.bind(this);
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/users',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
            ...(this.state.selectedStartDate ? {createdFrom: moment(this.state.selectedStartDate).toISOString()} : null),
            ...(this.state.selectedEndDate ? {createdTo: moment(this.state.selectedEndDate).toISOString()} : null),
          }
        });
      this.setState({
        users: data.users,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  getColumns = t => [
    {
      accessor: 'profilePicture',
      Cell: props => <div className='position-relative'>
        <img src={props.value ? props.value : '/assets/img/sample-avatar.jpg'} className="avatar-mini" alt="avatar-mini"/>
        {!!props.original.hasNote && <div
          className='position-absolute bg-warning'
          style={{width: 20, height: 20, bottom: 2, left: 0, borderRadius: 10}}>
          <ToolTip id={`go_notes_${props.original.id}`} text={t('Has Note')}>
          <Link to={{
            pathname: '/dashboard/users/' + props.original.id,
            state: {
              ...props.original,
              section: 'Notes',
            },
          }}>
            <i className="icon-Information text-white" style={{fontSize: 20}}/>
          </Link>
        </ToolTip>
        </div>}
      </div>,
      width: 60,
    },
    {
      Header: t('First Name'),
      accessor: 'firstName',
      filterable: true,
      Filter: ReactTableTextFilter,
    },
    {
      Header: t('Last Name'),
      accessor: 'lastName',
      filterable: true,
      Filter: ReactTableTextFilter,
    },
    {
      Header: t('Email'),
      accessor: 'email',
      minWidth: 160,
      filterable: true,
      Filter: ReactTableTextFilter,
    },
    {
      Header: t('Email Status'),
      accessor: 'emailConfirmed',
      Cell: props => <span className={props.value ? 'text-success' : 'text-danger'}>{props.value ? t('confirmed') : t('not confirmed')}</span>,
      filterable: true,
      width: 100,
      Filter: this.renderEmailConfirmedFilter,
    },
    {
      Header: t('National Code'),
      accessor: 'nationalCode',
      width: 150,
      filterable: true,
      Filter: ReactTableTextFilter,
    },
    {
      Header: t('SSN Status'),
      accessor: 'shahkarVerified',
      Cell: props => <span className={props.value ? 'text-success' : 'text-danger'}>{props.value ? t('confirmed') : t('not confirmed')}</span>,
      filterable: false,
      width: 100,
    },
    {
      Header: t('Phone Number'),
      accessor: 'phoneNumber',
      width: 150,
      filterable: true,
      Filter: ReactTableTextFilter,
    },
    {
      Header: t('Phone Number Status'),
      accessor: 'phoneNumberVerified',
      Cell: props => <span className={props.value ? 'text-success' : 'text-danger'}>{props.value ? t('confirmed') : t('not confirmed')}</span>,
      filterable: true,
      width: 100,
      Filter: this.renderMobileConfirmedFilter,
    },
    {
      Header: t('Registration Date'),
      accessor: 'createdAt',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      width: 140,
      filterable: true,
      Filter: this.renderDateFilter,
    },
    {
      Header: t('Actions'),
      width: 110,
      Cell: props =>
        <div className='d-flex flex-row align-items-center justify-content-around'>
          <ToolTip id={`go_wallets_${props.original.id}`} text={t('View Wallets')}>
            <Link to={{
              pathname: '/dashboard/users/' + props.original.id,
              state: {
                ...props.original,
                section: 'Wallets',
              },
            }}>
              <i className="icon-Wallet-2 text-large"/>
            </Link>
          </ToolTip>
          <ToolTip id={`go_transactions_${props.original.id}`} text={t('View Transactions')}>
            <Link to={{
              pathname: '/dashboard/users/' + props.original.id,
              state: {
                ...props.original,
                section: 'Transactions',
              },
            }}>
              <i className="icon-Bulleted-Lists text-large"/>
            </Link>
          </ToolTip>
          <ToolTip id={`view_${props.original.id}`} text={t('View Profile')}>
            <Link to={{
              pathname: '/dashboard/users/' + props.original.id,
              state: {...props.original},
            }}>
              <i className="simple-icon-eye view-icon text-large"/>
            </Link>
          </ToolTip>
        </div>,
    },
  ];

  renderEmailConfirmedFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: true, label: t('confirmed')},
      {value: false, label: t('not confirmed')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderMobileConfirmedFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: true, label: t('confirmed')},
      {value: false, label: t('not confirmed')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderDateFilter({onChange}) {
    const {selectedStartDate, selectedEndDate} = this.state;
    return <ReactTableDateFilter
      onChange={onChange}
      handleDateChange={this.handleDateChange}
      selectedStartDate={selectedStartDate}
      selectedEndDate={selectedEndDate}
    />;
  }

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  render() {
    const {t} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={this.props.match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <ReactTable
                  manual
                  className="-highlight"
                  data={this.state.users}
                  pages={this.state.pages}
                  loading={this.state.loading}
                  sortable={false}
                  resizable={true}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  defaultPageSize={25}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(Lists);
